// extracted by mini-css-extract-plugin
export default {"checkout_summary":"rq","checkout_summary_wrapper":"sq","summary_items":"tq","line_items_wrapper":"uq","separator":"vq","order_summary":"wq","line_item":"xq","order__summary_item_title":"yq","recurringdis":"zq","note":"Aq","carbon_emission":"Bq","unlock_savings":"Cq","member_perk":"Eq","info":"Fq","no_items":"Gq","promo":"Hq","order_summary_mobile":"Iq","open_summary_mobile":"Jq","fixed_bottom_info":"Kq","open_info":"Lq","text":"Mq","open_summary":"Nq"};
    if(module.hot) {
      // 1715276855652
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  